import type { RefObject } from 'react';

/** Viewport below which the panoramic pickers stay bottom sheets instead of dropdowns. */
export const SELECTION_DROPDOWN_MOBILE_QUERY = '(max-width: 699px)';

export type SelectionDropdownCloseReason = 'select' | 'escape' | 'outside';

/** One row of the dropdown; `value` is the caller's own item, handed back on select. */
export type SelectionDropdownItem<T = unknown> = {
  key: string;
  label: string;
  /** Secondary text after the label, e.g. a dial code */
  detail?: string;
  iconSrc: string | null;
  selected: boolean;
  value: T;
};

export type SelectionDropdownTexts = {
  searchPlaceholder: string;
  /** Accessible name of the list */
  listLabel: string;
  emptyTitle: string;
  emptySubtitle: string;
};

export type SelectionDropdownExtras = {
  /** Set to false when a parent (e.g. CustomSelect) already closes the picker on outside clicks */
  closeOnOutsideClick?: boolean;
  /** Elements whose clicks must not count as "outside" (typically the trigger, so it can toggle) */
  outsideClickIgnoreRefs?: RefObject<HTMLElement>[];
  /** Anchoring modifier(s), e.g. `_country`, `_region-code`, `_currency`, `_currency-field` */
  className?: string;
  listboxId?: string;
};

export type SelectionDropdownProps<T = unknown> = SelectionDropdownExtras & {
  isOpen: boolean;
  onClose: (reason?: SelectionDropdownCloseReason) => void;
  /** Rows to show — already filtered by the caller for `searchQuery` */
  items: SelectionDropdownItem<T>[];
  onSelect: (item: SelectionDropdownItem<T>) => void;
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  texts: SelectionDropdownTexts;
  showIcons?: boolean;
  centred?: boolean;
};
